import Vue from 'vue'
import VueRouter from 'vue-router'
// import GAuth from 'vue-google-oauth2'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import VueTheMask from 'vue-the-mask'
import moment from 'moment'
import Roster from './components/Roster'
import CourseRoster from './components/CourseRoster'
import Grades from './components/Grades'
import GradesRoster from './components/GradesRoster'
import Profile from './components/Profile'
import Courses from './components/Courses'
import PaymentReceipt from './components/PaymentReceipt'
import Support from './components/Support'
import Axios from 'axios'
import store from './store'

Vue.config.productionTip = false

Vue.use(VueRouter)

Vue.prototype.$http = Axios

const token = localStorage.getItem('token')
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = token
}

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('MMMM D, YYYY')
  }
})


// const gauthOptions = {
//   clientId: '291420199045-11k164cqgfspmv7am4dmcl7pfj1u4030.apps.googleusercontent.com',
//   scope: 'profile email',
//   prompt: 'select_account'
// }

// Vue.use(GAuth, gauthOptions)

const routes = [
  
  { path: '/roster', component: Roster }, 
  { path: '/roster/:id', component: CourseRoster },
  { path: '/grades', component: Grades},
  { path: '/grades/:id', component: GradesRoster },
  { path: '/profile', component: Profile },
  { path: '/courses', component: Courses },
  { path: '/payment', component: PaymentReceipt },
  { path: '/registration', beforeEnter() { window.open('https://class.adelphi.edu/hsp/') } },
  { path: '/transcript', beforeEnter() { window.open('https://www.credentials-inc.com/cgi-bin/DVCGITP.pgm?ALUMTRO002666') } },
  { path: '/support', component: Support }
]

// mode: 'history',
const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

window.vm = {}

window.vm = new Vue({
  vuetify,
  router,
  store,
  VueTheMask,
  render: h => h(App)
}).$mount('#app')

